import React, { useState, useEffect } from 'react';
import 'antd/dist/antd.min.css';
import {
    Button,
    Drawer,
    Table,
    message,
    Upload,
    Dropdown,
    Menu,
    Space
} from 'antd';
import {
    MenuOutlined,
    InboxOutlined,
    DownOutlined,
    SmileOutlined
} from '@ant-design/icons';
import { arrayMoveImmutable } from 'array-move';

import cloneDeep from 'lodash/cloneDeep';

import {
    getHelpContent,
    deleteHelpContent,
    setHelpContentOrder
} from 'services/help.js';

import {
    SortableContainer,
    SortableElement,
    SortableHandle
} from 'react-sortable-hoc';
import EditDrawer from './EditDrawer';

const DragHandle = SortableHandle(() => (
    <MenuOutlined
        style={{
            cursor: 'grab',
            color: '#999'
        }}
    />
));

const menu = (
    <Menu
        items={[
            {
                key: '1',
                label: (
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.antgroup.com"
                    >
                        1st menu item
                    </a>
                )
            },
            {
                key: '2',
                label: (
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.aliyun.com"
                    >
                        2nd menu item (disabled)
                    </a>
                ),
                icon: <SmileOutlined />,
                disabled: true
            }
        ]}
    />
);

const SortableItem = SortableElement((props) => <tr {...props} />);
const SortableBody = SortableContainer((props) => <tbody {...props} />);

// ===================
const { Dragger } = Upload;

const HelpDrawer = (props) => {
    const [rerenderTableAfterChangeData, setRerenderTableAfterChangeData] =
        useState(false);

    const [sortedOrderToSend, setSortedOrderToSend] = useState();

    const [editData, setEditData] = useState({
        mainTitle: 'MainTitle',
        title: 'title',
        description: 'description',
        image: 'image'
    });

    const editedRow = (data) => {
        setEditData(data);
    };

    let sendDataHelpDrawerId = '';
    let title = '';

    // useEffect(()=>{

    // },[])
    if (props.sendDataHelpDrawer !== undefined) {
        sendDataHelpDrawerId = props.sendDataHelpDrawer.id;
        title = props.sendDataHelpDrawer.name;
    }

    const propsDragger = {
        name: 'image',
        multiple: true,
        action: `${process.env.REACT_APP_API_URL}/api/v1/generic/help-content/`,
        data: { help_item: sendDataHelpDrawerId },
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`
        },

        beforeUpload: () => {
            return new Promise((r) => setTimeout(r, 2000));
        },

        onChange(info) {
            const { status } = info.file;

            if (status !== 'uploading') {
                console.log(info.file, info.fileList);
            }

            if (status === 'done') {
                message.success(
                    `${info.file.name} file uploaded successfully.`
                );

                if (
                    info.file.name ===
                    info.fileList[info.fileList.length - 1].name
                ) {
                    setHelpContentOrder(props.sendDataHelpDrawer.id, []).then(
                        () => {
                            setRerenderTableAfterChangeData(
                                !rerenderTableAfterChangeData
                            );
                        }
                    );
                } else {
                    console.log(`notlastFile:`, info.file.name);
                }
            } else if (status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        },

        onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);
        }
    };

    const [data, setData] = useState([]);

    const columns = [
        {
            title: 'Sort',
            dataIndex: 'sort',
            width: 30,
            className: 'drag-visible',
            render: () => <DragHandle />
        },
        {
            title: 'Title',
            dataIndex: 'title',
            className: 'drag-visible'
        },
        {
            title: 'Description',
            dataIndex: 'description'
        },
        {
            title: 'Order',
            dataIndex: 'index'
        },
        // {
        //     title: 'Address',
        //     dataIndex: 'address'
        // },
        {
            render: (t, r, i) => {
                return (
                    <Button
                        // style={{ cursor: 'pointer' }}
                        onClick={() => {
                            showEditDrawerHelp();
                            editedRow(r);
                        }}
                    >
                        Edit
                    </Button>
                );
            }
        },
        {
            render: (t, r, i) => {
                return (
                    <Button
                        onClick={() => {
                            deleteHelpContent(r.id);
                            setTimeout(() => {
                                setRerenderTableAfterChangeData(
                                    !rerenderTableAfterChangeData
                                );
                            }, 1000);
                        }}
                        type="primary"
                        danger
                    >
                        Delete
                    </Button>
                );
            }
        }
    ];

    const [visibleEditDrawerHelp, setVisibleEditDrawerHelp] = useState(false);

    const showEditDrawerHelp = () => {
        setVisibleEditDrawerHelp(true);
    };

    const onCloseEditDrawerHelp = () => {
        setVisibleEditDrawerHelp(false);
        setEditData();
    };

    useEffect(() => {
        getHelpContent(props.sendDataHelpDrawer.id).then((res) => {
            let newdata = [];
            for (let index in res.data) {
                let item = res.data[index];
                newdata.push({
                    id: item.id,
                    key: item.help_item,
                    title: item.title,
                    description: item.description,
                    index: item.order,
                    image: item.image
                });
            }

            setData(newdata);
        });
    }, [
        rerenderTableAfterChangeData,
        props.sendDataHelpDrawer,
        visibleEditDrawerHelp
    ]);

    const onSortEnd = ({ oldIndex, newIndex }) => {
        if (oldIndex !== newIndex) {
            const newData = arrayMoveImmutable(
                data.slice(),
                oldIndex,
                newIndex
            ).filter((el) => !!el);
            setData(newData);
            let newOrder = [];

            for (let i in newData) {
                let item = newData[i];
                newOrder.push(item.id);
            }

            setHelpContentOrder(data.key, newOrder);
            setRerenderTableAfterChangeData(!rerenderTableAfterChangeData);
        }
    };

    const DraggableContainer = (props) => (
        <SortableBody
            useDragHandle
            disableAutoscroll
            helperClass="row-dragging"
            onSortEnd={onSortEnd}
            {...props}
        />
    );

    const DraggableBodyRow = ({ className, style, ...restProps }) => {
        // function findIndex base on Table rowKey props and should always be a right array index
        const index = data.findIndex(
            (x) => x.index === restProps['data-row-key']
        );
        return <SortableItem index={index} {...restProps} />;
    };

    return (
        <>
            <Drawer
                title={title}
                placement="right"
                onClose={props.onCloseDrawerHelp}
                visible={props.visibleDrawerHelp}
                width={800}
                className="drawer-main-help"
            >
                <Dragger
                    showUploadList={false}
                    {...propsDragger}
                    style={{ marginBottom: '30px' }}
                >
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">
                        Click or drag file to this area to upload
                    </p>
                    <p className="ant-upload-hint">
                        Support for a single or bulk upload. Strictly prohibit
                        from uploading company data or other band files
                    </p>
                </Dragger>

                <Table
                    pagination={false}
                    dataSource={data}
                    columns={columns}
                    rowKey="index"
                    components={{
                        body: {
                            wrapper: DraggableContainer,
                            row: DraggableBodyRow
                        }
                    }}
                />
                {visibleEditDrawerHelp ? (
                    <EditDrawer
                        visibleEditDrawerHelp={visibleEditDrawerHelp}
                        setVisibleEditDrawerHelp={setVisibleEditDrawerHelp}
                        onCloseEditDrawerHelp={onCloseEditDrawerHelp}
                        editData={editData}
                        setEditData={setEditData}
                        setRerenderTableAfterChangeData={
                            setRerenderTableAfterChangeData
                        }
                        rerenderTableAfterChangeData={
                            rerenderTableAfterChangeData
                        }
                    />
                ) : null}
            </Drawer>
        </>
    );
};

export default HelpDrawer;
